
import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Address extends Vue {
  ccxStore: any = {}

  mounted () {
    this.ccxStore = this.$store.state.user.ccxStore
  }

  openManage () {
    this.$router.push({
      path: '/applyccxstoredetails',
    })
  }
}
